import EnrollActivityManagerContainer from "../../container/admin/EnrollActivityManager";

const EnrollActivityManager = () => {
    return <EnrollActivityManagerContainer />;
};

export default EnrollActivityManager;